<template>
      <TheFooter>
        <div>
          <!--footer-->
          <a href="#">Lead Database</a>
          <span class="ml-1">&copy; 2020 bytes technolab.</span>
        </div>
        <div class="ml-auto">
          <span class="mr-1">Powered by</span>
          <a href="#">Lead Database</a>
        </div>
      </TheFooter>
</template>
<script>
import { Footer as TheFooter } from '@coreui/vue'
export default {
  name: 'DefaultFooter',
  components: {
    TheFooter
  },
}
</script>
